const TSHIRT_SIZE_ORDER = ['x', 'xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'];

export type TshirtComparison = Record<string, Record<string, number>>;

function yearData(comparison: TshirtComparison, year: number): Record<string, number> {
    return comparison[String(year)] ?? {};
}

function sortTshirtSizes(sizes: string[]): string[] {
    return [...sizes].sort((a, b) => {
        const aIndex = TSHIRT_SIZE_ORDER.indexOf(a.toLowerCase());
        const bIndex = TSHIRT_SIZE_ORDER.indexOf(b.toLowerCase());
        if (aIndex === -1 && bIndex === -1) {
            return a.localeCompare(b);
        }
        if (aIndex === -1) {
            return 1;
        }
        if (bIndex === -1) {
            return -1;
        }
        return aIndex - bIndex;
    });
}

export function compareTshirtYears(
    comparison: TshirtComparison,
    lastYear: number,
    thisYear: number,
): {
    data: Array<Record<string, string | number>>;
    series: Array<{name: string; color: string}>;
} {
    const lastYearKey = String(lastYear);
    const thisYearKey = String(thisYear);
    const lastYearData = yearData(comparison, lastYear);
    const thisYearData = yearData(comparison, thisYear);

    const sizes = sortTshirtSizes([
        ...new Set([...Object.keys(lastYearData), ...Object.keys(thisYearData)]),
    ]);

    const data: Array<Record<string, string | number>> = sizes.map((size) => ({
        size,
        [lastYearKey]: lastYearData[size] ?? 0,
        [thisYearKey]: thisYearData[size] ?? 0,
    }));

    const series = [
        {name: lastYearKey, color: 'green.6'},
        {name: thisYearKey, color: 'blue.6'},
    ];

    return {data, series};
}
